// extracted by mini-css-extract-plugin
module.exports = {"main-component":"featureLounging_main-component__2c2aW"};